import type { ReactNode } from "react";
import ProfilePicture from "./Profile/ProfilePicture";
import { useProfilePicture } from "hooks/useProfilePicture";

interface AppDropdownProps {
  id: string;
  imgSrc?: string | null | undefined;
  icon?: string | undefined;
  name?: string | undefined;
  children: ReactNode;
}

export default function AppDropdown({ id, imgSrc, icon, name, children }: AppDropdownProps) {
  const { hasProfilePicture } = useProfilePicture();
  const avatarNameGap = name ? (hasProfilePicture ? '0.625rem' : '0.875rem') : '0';

      return (
        <div className="dropdown">
            <button
                type="button"
                className="btn btn-link text-primary dropdown-toggle d-flex align-items-center border-0"
                style={{ textDecoration: 'none', fontWeight: 'normal' }}
                id={id}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {icon && <i className={icon}></i>}
                {imgSrc && (
                  <ProfilePicture
                    width={32}
                    height={32}
                    additionalStyles={{ marginRight: avatarNameGap }}
                  />
                )}
                {name && <span style={{ fontWeight: 'normal' }}>{name}</span>}
              </button>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby={id} style={{ borderTop: '3px solid #0d6efd', minWidth: '250px' }}>
                {children}
              </ul>
        </div>
      )
}